export default __webpack_public_path__ + "./image/5155168f3236dd2a69224584f5322d9f.png";